import { render, staticRenderFns } from "./createBrexComponent.vue?vue&type=template&id=8651d7b2"
import script from "./createBrexComponent.vue?vue&type=script&lang=js"
export * from "./createBrexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports